module.exports = __webpack_public_path__ + "img/notice.0f2124cd.png";